<obg-m-dialog-layout #dialog dialog [hideClose]="true" [hideFooter]="true">
	<img obgImageContent="general.self-exclusion-warning" />
	<h1>{{ "time-off.confirm-title" | translate }}</h1>
	<p [innerHTML]="'time-off.confirm-message' | translate"></p>
	<p class="period" [innerHTML]="data?.timeout.text | translate"></p>
	<button
		mat-flat-button
		test-id="time-off-confirm-button"
		data-test-id="time-off-confirm-button"
		color="accent"
		(click)="confirm()"
	>
		{{ "general.ok" | translate }}
	</button>
	<button
		mat-stroked-button
		test-id="time-off-cancel-button"
		data-test-id="time-off-cancel-button"
		color="primary"
		(click)="closeDialog()"
	>
		{{ "general.cancel" | translate }}
	</button>
</obg-m-dialog-layout>
